function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".wedding_lg_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1e88e5}.wedding_lg_svg__st1{fill:#371447}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "wedding_lg_svg__st0",
  d: "M10 63.9s-2.1-12.2 5.1-12.3c7.3-.1 51.4.2 51.4.2s4.7-.5 4.8 6.9v5.4s-6.9-.4-8.4-6.3c0 0-1.5 5.8-7.5 6.1-6.1.3-7.4-6.7-7.4-6.7s-1.3 6.5-6.8 6.7c-5.5.2-8.2-5.8-8.2-5.8s-1.8 5.7-6.9 5.6c-5.2-.1-6.8-2.7-7.9-5.7-.1 0-1.9 6.6-8.2 5.9zM15.6 46s-1.8-10.2 4.2-10.2c6-.1 42.3.1 42.3.1s3.8-.4 4 5.8v4.5s-6-.3-7.2-5.2c0 0-.9 4.8-5.8 5S47 40.5 47 40.5s-1.1 5.4-5.6 5.5-6.5-4.5-6.5-4.5-1.7 4.4-6 4.3c-4.2-.1-4.9-2.1-5.9-4.6 0 0-2.2 5.4-7.4 4.8zm4.6-14.9s-1.5-7.8 3.3-7.9 34 .1 34 .1 3.1-.3 3.2 4.7v3.6s-4.2-.4-5.3-4.4c0 0-.8 3.7-4.8 3.9s-4.8-4-4.8-4-1.1 4-4.7 4.1c-3.6.1-4.9-3.7-4.9-3.7s-1.3 3.8-4.8 3.7-4.1-1.7-4.9-3.8c0 .1-2.1 4.2-6.3 3.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy",
  className: "wedding_lg_svg__st1",
  d: "M40.7 10.3c1.5-1.4 3.5-1.7 5.2-.9l.1.1c2.1 1.2 2.8 4.2 1.4 6.7-.4.7-.8 1.3-1.4 1.7l-5.5 4.9-5.3-4.9c-.6-.5-1-1.1-1.4-1.7-1.3-2.5-.7-5.5 1.5-6.7 1.7-.9 3.7-.5 5.2.8h.2zm4.7 6.9c.5-.4.8-.9 1.1-1.4 1.1-2.1.6-4.5-1.1-5.4h-.1c-1.4-.7-3.1-.2-4.3 1.2l-.4.4-.4-.4c-1.2-1.4-3-1.9-4.4-1.1-1.7.9-2.2 3.3-1.1 5.4.3.6.7 1 1.2 1.4l4.7 4.3 4.8-4.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-18",
  className: "wedding_lg_svg__st1",
  d: "M66.2 51.2c3 0 5.5 2.5 5.5 5.5v14.7H9.5V56.7c0-3 2.5-5.5 5.5-5.5h51.2zm4.5 5.5c0-2.5-2-4.5-4.5-4.5H15c-2.5 0-4.5 2-4.5 4.5v13.7h60.2V56.7z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-22",
  className: "wedding_lg_svg__st1",
  d: "M60.9 35.3c3 0 5.5 2.5 5.5 5.5v11.3H14.8V40.8c0-3 2.5-5.5 5.5-5.5h40.6zm4.5 5.5c0-2.5-2-4.5-4.5-4.5H20.3c-2.5 0-4.5 2-4.5 4.5v10.3h49.6V40.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-24",
  className: "wedding_lg_svg__st1",
  d: "M56 22.5c3 0 5.5 2.5 5.5 5.5v6.9c0 .4 0 .7-.1 1.1l-.1.4H19.6l-.1-.4c-.1-.4-.1-.7-.1-1.1V28c0-3 2.5-5.5 5.5-5.5H56zm4.4 12.8V28c0-2.5-2-4.5-4.5-4.5H25c-2.5 0-4.5 2-4.5 4.5v7.4h39.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-25",
  className: "wedding_lg_svg__st1",
  d: "M18.7 56.3c0 3.9 3.1 7 7 7s7-3.1 7-7h1c0 3.9 3.1 7 7 7s7-3.1 7-7h1c0 3.9 3.1 7 7 7s7-3.1 7-7h1c0 3.9 3.1 7 7 7h.2v1h-.2c-3.4 0-6.4-2.2-7.5-5.2-1.1 3-4.1 5.2-7.5 5.2s-6.4-2.2-7.5-5.2c-1.1 3-4.1 5.2-7.5 5.2-3.3 0-6.2-2.1-7.4-5l-.1-.3-.2.4c-1.2 2.9-4 5-7.4 5s-6.2-2.1-7.4-5l-.1-.3-.1.3c-1.2 2.9-4 5-7.4 5h-.2v-1h.2c3.9 0 7-3.1 7-7l1.1-.1z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-7",
  className: "wedding_lg_svg__st1",
  d: "M23.4 40c0 3 2.5 5.5 5.5 5.5s5.5-2.5 5.5-5.5h1c0 3 2.5 5.5 5.5 5.5s5.5-2.5 5.5-5.5h1c0 3 2.5 5.5 5.5 5.5s5.5-2.5 5.5-5.5h1c0 3 2.5 5.5 5.5 5.5h.7v1h-.7c-2.7 0-5-1.6-6-4-1 2.3-3.3 4-6 4s-5-1.6-6-4c-1 2.3-3.3 4-6 4s-5-1.6-6-4c-1 2.3-3.3 4-6 4s-5-1.6-6-4c-1 2.3-3.3 4-6 4-.4 0-.8 0-1.2-.1v-1c.4.1.8.1 1.2.1 3 0 5.5-2.5 5.5-5.5h1z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "wedding_lg_svg__Combined-Shape-Copy-10",
  className: "wedding_lg_svg__st1",
  d: "M27 26.3c.1 2.4 2 4.3 4.3 4.3s4.3-1.9 4.3-4.2v-.1h1v.1c0 2.4 2 4.2 4.3 4.2s4.3-1.9 4.3-4.2v-.1h1v.1c0 2.4 2 4.2 4.3 4.2s4.3-1.9 4.3-4.2v-.1h1v.1c0 2.4 2 4.2 4.3 4.2h.3v1h-.3c-2 0-3.8-1.2-4.7-2.9l-.1-.2-.1.2c-.9 1.7-2.7 2.9-4.7 2.9-2.1 0-4-1.3-4.8-3.1v.1c-.9 1.8-2.7 3-4.8 3-2 0-3.8-1.2-4.7-2.9l-.1-.2-.1.3c-.9 1.7-2.7 2.9-4.7 2.9s-3.8-1.2-4.7-2.9l-.1-.2-.1.2c-.9 1.7-2.7 2.9-4.7 2.9-.4 0-.8 0-1.2-.1v-1c.4.1.8.2 1.2.2 2.3 0 4.3-1.9 4.3-4.2v-.1l1-.2z"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval",
  className: "wedding_lg_svg__st0",
  cx: 18.2,
  cy: 65.8,
  r: 1.1
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-27",
  className: "wedding_lg_svg__st0",
  cx: 48.4,
  cy: 65.8,
  r: 1.1
});

var _ref12 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-26",
  className: "wedding_lg_svg__st0",
  cx: 33.3,
  cy: 65.8,
  r: 1.1
});

var _ref13 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-28",
  className: "wedding_lg_svg__st0",
  cx: 63.5,
  cy: 65.8,
  r: 1.1
});

var _ref14 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval_1_",
  className: "wedding_lg_svg__st0",
  cx: 23,
  cy: 47.5,
  r: 1
});

var _ref15 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-27_1_",
  className: "wedding_lg_svg__st0",
  cx: 46.7,
  cy: 47.5,
  r: 1
});

var _ref16 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-26_1_",
  className: "wedding_lg_svg__st0",
  cx: 34.8,
  cy: 47.5,
  r: 1
});

var _ref17 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-28_1_",
  className: "wedding_lg_svg__st0",
  cx: 58.6,
  cy: 47.5,
  r: 1
});

var _ref18 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval_2_",
  className: "wedding_lg_svg__st0",
  cx: 26.5,
  cy: 32.6,
  r: 1
});

var _ref19 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-27_2_",
  className: "wedding_lg_svg__st0",
  cx: 45.8,
  cy: 32.6,
  r: 1
});

var _ref20 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-26_2_",
  className: "wedding_lg_svg__st0",
  cx: 36.1,
  cy: 32.6,
  r: 1
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  id: "wedding_lg_svg__Oval-Copy-28_2_",
  className: "wedding_lg_svg__st0",
  cx: 55.5,
  cy: 32.6,
  r: 1
});

function SvgWeddingLg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

export default SvgWeddingLg;